import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { esmobiotv } from "../../constants/esmobiotv";
import { bidiotvMovies } from "../../constants/bidiotvmovies";
import { showSearchBar } from '../../actions/HeaderActions';
import { searchText } from '../../actions/SearchActions';
import { getVideoOrChannelRelatedData } from '../../actions/PlayActions';
import { config } from '../../constants/domainConfig';
class SearchPageforES extends Component {
    constructor(props) {
        super(props);
    };

    componentWillMount() {
        this.props.showSearchBar(true);
        this.clearText();

    }

    clearText() {
        this.props.searchText('');
    }

    componentWillUnmount() {
    }

    gotoViewAll(data){
        if(config.title === "es") {
            this.props.history.push(`/movies/${data.id}?uid=${this.props.access.uid}`);
        }
        if(config.title === "bidiotv") {
            this.props.history.push(`/videos/${data.id}?uid=${this.props.access.uid}`);
        }
    }
    mapCategoryList() {
        if (config.title === "es") {
            return (
                esmobiotv.map((e) => {
                    return (
                        <li className="search-category-list__item" onClick={() => this.gotoViewAll(e)}>{e.name}</li>
                    )
                })
            )
        }
        if (config.title === "bidiotv") {
            return (
                bidiotvMovies.map((e) => {
                    return (
                        <li className="search-category-list__item" onClick={() => this.gotoViewAll(e)}>{e.name[config.subDomain]}</li>
                    )
                })
            )
        }
    }

    render(){
        return (
            <section className="search-page">
                <div className="search-page--es">
                    <ul className="list-unstyled search-category-list">
                        {this.mapCategoryList()}
                    </ul>
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        header: state.HeaderReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        search: state.SearchReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        searchText,
        getVideoOrChannelRelatedData,
        showSearchBar
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchPageforES);



// WEBPACK FOOTER //
// ./src/components/SearchPage/SearchPageforES.js